export const ENTITIES_ACCESS_LEVELS = {
  JIRA_APP: 1,
  WEB_APP: 2,
  CROSS_PLATFORM_APP: 4,
  AZURE_APP: 8
}

export const AVAILABLE_FOR_ALL_PLATFORMS =
  ENTITIES_ACCESS_LEVELS.JIRA_APP |
  ENTITIES_ACCESS_LEVELS.WEB_APP |
  ENTITIES_ACCESS_LEVELS.CROSS_PLATFORM_APP |
  ENTITIES_ACCESS_LEVELS.AZURE_APP

export const AVAILABLE_FOR_JIRA_AND_AZURE =
  ENTITIES_ACCESS_LEVELS.JIRA_APP | ENTITIES_ACCESS_LEVELS.AZURE_APP

export const AVAILABLE_FOR_JIRA_PLATFORM_AND_OTHERS_WITH_CONNECTION_TO_JIRA =
  ENTITIES_ACCESS_LEVELS.JIRA_APP |
  ENTITIES_ACCESS_LEVELS.WEB_APP |
  ENTITIES_ACCESS_LEVELS.CROSS_PLATFORM_APP
